"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_1 = require("./react");

var createMemo_1 = require("./createMemo");

var useRenderProp = function useRenderProp(element) {
  if (process.env.NODE_ENV !== 'production') {
    if (!React.isValidElement(element)) {
      throw new TypeError('useRenderProp element to be a valid React element ' + 'such as <MyRenderProp />.');
    }
  }

  var _react_1$useState = react_1.useState([]),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  var useSetState = createMemo_1.default(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return setState(args);
  });
  var render = react_1.useCallback(function () {
    useSetState.apply(void 0, arguments);
    return null;
  }, []);
  var cloned = React.cloneElement(element, {
    render: render,
    children: render
  });
  return [cloned, state];
};

exports.default = useRenderProp;